<template>
  <div class="container-box" v-loading="oLoading.pageLoading">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">{{ pageTitle }}</template>
        <div class="splitline"></div>
      </QS-h3-title>
      <div class="content-box">
        <div class="content-box__title">
          <div class="icon"></div>
          <span>基础信息</span>
        </div>
        <div class="content-box__content">
          <div class="content-item basic-info">
            <p class="title">方案信息</p>
            <el-form ref="formRef" :rules="baseRules" :model="baseDefaultValue">
              <column-box :column="2">
                <el-form-item label="方案名称" prop="name">
                  <el-input
                    v-model="baseDefaultValue.name"
                    clearable
                    placeholder="不对外展示，最多20字"
                    maxlength="20"
                  />
                </el-form-item>
                <CarBrandSeriesModel
                  v-model="baseDefaultValue.brandSeriesModel"
                  :brandSeriesModelName="baseDefaultValue.brandSeriesModelName"
                  :showModel="true"
                  :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
                />
                <el-form-item label="城市" prop="cityCodes">
                  <QS-select
                    v-model="baseDefaultValue.cityCodes"
                    clearable
                    filterable
                    multiple
                    collapse-tags
                    placeholder="请选择城市"
                    :disabled="cityDisabled"
                    :option-data="allCities"
                    :option-config="{
                      labelKey: 'city',
                      valueKey: 'adcode',
                    }"
                    popper-class="plan-city-popper"
                  >
                  </QS-select>
                </el-form-item>
                <el-form-item label="车龄" prop="carAge">
                  <el-select
                    v-model="baseDefaultValue.carAge"
                    clearable
                    placeholder="请选择车龄"
                  >
                    <el-option
                      v-for="item in carAgeOptions"
                      :label="item.name"
                      :value="item.code"
                      :key="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="是否有车证" prop="hasDrivingLicense">
                  <el-radio-group v-model="baseDefaultValue.hasDrivingLicense">
                    <el-radio
                      v-for="item in DRIVING_LICENSE_OPTIONS"
                      :label="item.value"
                      :key="item.value"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
          <div class="content-item">
            <p class="title">租赁规则</p>
            <!-- 确认租赁信息 -->
            <personSchemeRentInfo
              ref="schemeRentInfo"
              :defaultRentInfo="leaseInfoParams"
              :tableData="defaultTable"
              @updateInfo="updateRentDateInfo"
              @formChange="formChange"
            />
          </div>
          <!-- 司机权益 -->
          <!-- eslint-disable vue/no-unused-refs -->
          <div class="content-item">
            <p class="title">司机权益</p>
            <LeaseSchemeCampaign
              ref="leaseSchemeCampaignRef"
              v-model="campaignBinding"
            />
          </div>
          <!-- eslint-enable vue/no-unused-refs -->
        </div>
      </div>
      <!-- 租赁费用 -->
      <div class="content-box" v-if="showLeaseFeeSection">
        <div class="content-box__title">
          <div class="icon"></div>
          <span>租赁费用</span>
        </div>
        <div class="content-box__content">
          <!-- 司机合作模式组件 -->
          <DriverCooperationRules
            ref="driverCooperRef"
            :rentDateInfo="rentDateInfo"
            :payPlanFee="leaseInfoParams.payPlanFee"
            :sceneType="'leasePlan'"
            v-if="
              rentDateInfo.rentCategory ===
              CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI
            "
            @autoAnchor="autoAnchor"
          />

          <!-- 租赁支付计划表格 -->
          <div v-else-if="showRentPlan" class="content-item">
            <p class="title">租赁账单</p>
            <RentPlanConfig
              ref="RentPlanConfig"
              :defaultTableData="feeTableData"
              :rentDateInfo="rentDateInfo"
              :specialType="1"
              :scene="SCENE_TYPE.LEASE_PLAN"
              :configDisabled="false"
              @autoAnchor="autoAnchor"
            />
          </div>
        </div>
      </div>

      <!-- 履约规则 -->
      <div class="content-box">
        <div class="content-box__title">
          <div class="icon"></div>
          <span>履约规则</span>
        </div>
        <div class="content-box__content">
          <el-form
            ref="storeFormRef"
            :model="baseDefaultValue"
            label-position="top"
            class="form-box"
          >
            <el-row :gutter="24">
              <!-- 签约主体 -->
              <el-col :span="12">
                <el-form-item label="签约主体">
                  <span>{{ signCompany || '--' }}</span>
                </el-form-item>
              </el-col>

              <!-- 可发车门店 -->
              <el-col :span="12">
                <el-form-item
                  label="可发车门店"
                  prop="storeIds"
                  :rules="[{ required: true, message: '请选择可发车门店' }]"
                >
                  <div class="store-select-wrap">
                    <el-select
                      v-model="baseDefaultValue.storeIds"
                      multiple
                      disabled
                      collapse-tags
                      placeholder="请选择门店"
                      class="store-name-select"
                    >
                      <el-option
                        v-for="item in storeTransferList"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      />
                    </el-select>
                    <el-button
                      type="primary"
                      size="small"
                      :disabled="!baseDefaultValue.cityCodes.length"
                      @click="storeDialogVisible = true"
                      >选择</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <!-- 门店选择弹窗 -->
          <el-dialog
            :visible.sync="storeDialogVisible"
            title="选择可发车门店"
            :close-on-click-modal="false"
            class="store-transfer-dialog"
          >
            <el-transfer
              v-model="storeDialogSelectedIds"
              :data="storeTransferList"
              :titles="['未选择门店', '已选择门店']"
              filterable
            />
            <div slot="footer" class="dialog-footer">
              <el-button @click="storeDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmStoreSelection"
                >确定</el-button
              >
            </div>
          </el-dialog>

          <!-- 合同模板 -->
          <ChooseContractTemplate
            ref="chooseContractTemplateRef"
            :defaultValue="defaultTemplateValue"
            source="leaseScheme"
            @saveSuccess="setTemplateIdAndAIResultInfo"
          />

          <!-- 履约条款组件（用车规则+还车说明） -->
          <LeaseRules
            v-if="baseDefaultValue.templateId"
            :rentDataInfo="rentDateInfo"
            ref="leaseRulesRef"
            :loading="leaseRulesLoading"
            :collapsible="true"
          />
        </div>
      </div>
      <!-- 操作 -->
      <template slot="bottomAction">
        <el-button @click="goPageBacks" size="mini">取消</el-button>
        <el-button
          :loading="oLoading.submit"
          type="primary"
          size="mini"
          @click="submitHandle"
          >提交</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
// api
import { checkBeforeSave, saveLeaseSchemeSignCheck } from '@/api/domain/leaseScheme'
import { depositAmountCheck } from '@/api/domain/purchase.js'
import { getAiAnalysisResult, getSimpleMerchantList } from '@/api/domain/organize.js'
import { storeListAll } from '@/api/domain/shop'
import { TEMPLATE_STATE_MAP } from '@/store/dict/templateDict.js'
// 组件
import ChooseContractTemplate from '@/components/ChooseContractTemplate'
// eslint-disable-next-line import/no-unresolved
import LeaseRules from './LeaseRules'
import LeaseSchemeCampaign from './LeaseSchemeCampaign.vue'
import DriverCooperationRules from '@/components/DriverCooperationRules'
import personSchemeRentInfo from '@/components/rentCalculateConfig/personSchemeRentInfo.vue'
import RentPlanConfig from '@/components/RentPlanConfig/index.vue'

// vuex
import { mapGetters } from 'vuex'

import {
  DEPOSIT_COLLECT_RULE,
  RENT_TYPE,
  SCENE_TYPE,
} from '@/components/RentPlanConfig/config'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict'
import { FEE_CODE_MAP, PAY_MODE } from '@/config/rentConfig'
import WindowCommunication from '@/utils/windowCommunication'
import { getEnum } from '@/api/global'
import { MODE_TYPE, MODE_TYPE_TEXT, DRIVING_LICENSE_OPTIONS } from '../const.js'
import addMixin from '../mixin/indexNew.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  name: 'AddPersonEditNew',
  mixins: [addMixin],
  components: {
    personSchemeRentInfo,
    RentPlanConfig,
    DriverCooperationRules,
    ChooseContractTemplate,
    LeaseRules,
    LeaseSchemeCampaign,
  },
  props: {
    // 编辑模式
    mode: {
      type: String,
      default: MODE_TYPE.ADD,
    },
  },
  data() {
    return {
      leaseInfoParams: {
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        rentPeriodType: '', // 租赁周期单位
        payMode: '', // 收款方式
      },
      rentDateInfo: {
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        rentPeriodType: '', // 租赁周期单位
        payMode: '',
      },
      oLoading: {
        pageLoading: true,
      },
      leaseRulesLoading: false,
      pageTitle: `${MODE_TYPE_TEXT[this.mode]}商城方案`,
      baseDefaultValue: {
        id: '',
        templateId: '',
        cityCodes: [],
        brandId: '',
        seriesId: '',
        modelId: '',
        state: '',
        cityNames: [],
        brandSeriesModel: {},
        brandSeriesModelName: {},
        gmtCreate: '',
        name: '',
        carAge: '',
        hasDrivingLicense: null,
        storeIds: [],
      },
      baseRules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        brandId: [{ required: true, message: '请选择', trigger: 'change' }],
        modelId: [{ required: true, message: '请选择', trigger: 'change' }],
        cityCodes: [
          { required: true, message: '请选择城市', trigger: 'change' },
        ],
        carAge: [{ required: true, message: '请选择车龄', trigger: 'change' }],
        hasDrivingLicense: [
          { required: true, message: '请选择是否有车证', trigger: 'change' },
        ],
        storeIds: [
          { required: true, message: '请选择可发车门店', trigger: 'change' },
        ],
      },
      defaultTable: [],
      feeTableData: [],
      id: '',
      SCENE_TYPE, // 场景类型
      CATEGORY_CODE_MAP,
      defaultTemplateValue: {
        id: '', // 模板id
        name: '', // 模板名称
      },
      CAR_MODEL_FILTER_SCENE,
      carAgeOptions: [],
      signCompany: '',
      storeTransferList: [],
      storeDialogVisible: false,
      storeDialogSelectedIds: [],
      campaignBinding: [],
      DRIVING_LICENSE_OPTIONS,
      storeFetchTimer: null,
    }
  },
  computed: {
    ...mapGetters(['allCities']),
    cityDisabled() {
      return !!this.$route.query?.scene
    },
    showRentPlan() {
      return this.rentDateInfo.rentCategory && this.baseDefaultValue.templateId
    },
    showLeaseFeeSection() {
      if (
        this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI
      ) {
        return true
      }
      return this.showRentPlan
    },
  },
  created() {
    this.id = this.$route.query.id || ''
    if (this.allCities.length === 0) {
      this.$store.dispatch('getCityListFn')
    }
    if (this.$route.query?.scene) {
      this.baseDefaultValue.modelId = this.$route.query?.modelId
        ? Number(this.$route.query?.modelId)
        : ''
      this.baseDefaultValue.cityCodes = this.$route.query?.cityCode
        ? [this.$route.query?.cityCode]
        : []
      // 从商品管理新增租赁方案进来的时候会携带品牌车系车型信息，需要赋值
      this.baseDefaultValue.brandId = this.$route.query?.brandId
        ? Number(this.$route.query?.brandId)
        : ''
      this.baseDefaultValue.seriesId = this.$route.query?.seriesId
        ? Number(this.$route.query?.seriesId)
        : ''
      this.baseDefaultValue.brandSeriesModel = {
        brandId: this.baseDefaultValue.brandId,
        seriesId: this.baseDefaultValue.seriesId,
        modelId: this.baseDefaultValue.modelId,
      }
    }
    this.fetchCarAgeOptions()
    this.fetchSignCompany()
  },
  watch: {
    storeDialogVisible(val) {
      if (val) {
        this.storeDialogSelectedIds = [...this.baseDefaultValue.storeIds]
      }
    },
    'baseDefaultValue.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.baseDefaultValue.brandId = brandId
        this.baseDefaultValue.seriesId = seriesId
        this.baseDefaultValue.modelId = modelId
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate('brandId')
          this.$refs.formRef.clearValidate('modelId')
        })
      },
      deep: true,
    },
    'baseDefaultValue.cityCodes': {
      handler(val) {
        clearTimeout(this.storeFetchTimer)
        if (val && val.length > 0) {
          this.storeFetchTimer = setTimeout(async () => {
            await this.fetchStoreByCity(val)
            if (!this._isSettingData) {
              this.baseDefaultValue.storeIds = this.storeTransferList.map(
                (item) => item.key,
              )
            }
            this._isSettingData = false
          }, 300)
        } else {
          this.storeTransferList = []
          this.baseDefaultValue.storeIds = []
        }
      },
    },
    'baseDefaultValue.templateId': {
      async handler(val) {
        if (val) {
          this.leaseRulesLoading = true
          const { code, data } = await getAiAnalysisResult({ id: val })
          if (code === 1) {
            this.$refs.leaseRulesRef.setFormData({
              rentCarRuleTip: data.rentCarRuleTip,
              returnCarRuleTip: data.returnCarRuleTip,
              rentCarRule: data.rentCarRule,
              returnCarRule: data.returnCarRule,
            })
          }
          this.leaseRulesLoading = false
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this.storeFetchTimer)
  },
  methods: {
    updateRentDateInfo(val, feeTableData) {
      this.rentDateInfo = {
        ...val,
      }
      this.feeTableData = feeTableData
    },
    autoAnchor(toastFlag) {
      this.$refs.schemeRentInfo.autoAnchorPoint(toastFlag)
    },
    buildFollowRentDepositPreviewParams(depositItem = {}) {
      const payPlanType = depositItem.payPlanType ?? RENT_TYPE.FIXEDRENT
      const payMode =
        depositItem.fundType === FEE_CODE_MAP.YA_JIN &&
        Number(depositItem.depositCollectRule) ===
          DEPOSIT_COLLECT_RULE.FOLLOW_RENT
          ? depositItem.rentPayMode ||
            depositItem.payMode ||
            this.rentDateInfo.payMode
          : depositItem.payMode || this.rentDateInfo.payMode
      const commonParams = {
        rentPlanFeeType: depositItem.fundType,
        bizType: 10,
        planId: this.id || undefined,
        startTime:
          depositItem.startTime || this.rentDateInfo.startStopDate?.[0],
        endTime: depositItem.endTime || this.rentDateInfo.startStopDate?.[1],
        payMode,
        customerDueDate: depositItem.customerDueDate || '',
      }
      const payPlanParams =
        payPlanType === RENT_TYPE.DYNAMICRENT
          ? {
            payPlanType,
            spId: depositItem.spId ?? '',
            dynamicType: depositItem.dynamicType ?? '',
            dynamicList: depositItem.dynamicList ?? [],
          }
          : {
            amountType: Number(depositItem.amountType ?? 0),
            amount:
                depositItem.fundType === FEE_CODE_MAP.YA_JIN &&
                Number(depositItem.depositCollectRule) ===
                  DEPOSIT_COLLECT_RULE.FOLLOW_RENT
                  ? depositItem.depositPeriodAmount ?? ''
                  : depositItem.amount ?? '',
          }
      const params = {
        ...commonParams,
        ...payPlanParams,
        rentCategory:
          depositItem.rentCategory || this.rentDateInfo.rentCategory,
        rentPeriod: depositItem.rentPeriod ?? this.rentDateInfo.rentPeriod,
        rentPeriodType:
          depositItem.rentPeriodType ?? this.rentDateInfo.rentPeriodType,
        renewal: 0,
      }

      if (
        depositItem.fundType === FEE_CODE_MAP.YA_JIN &&
        (Number(depositItem.depositCollectRule) ===
          DEPOSIT_COLLECT_RULE.CUSTOM_STAGES ||
          Number(depositItem.depositCollectRule) ===
            DEPOSIT_COLLECT_RULE.FOLLOW_RENT)
      ) {
        params.totalAmount = depositItem.amount ?? depositItem.totalAmount ?? ''
      }

      if (
        depositItem.fundType === FEE_CODE_MAP.YA_JIN &&
        Number(depositItem.depositCollectRule) ===
          DEPOSIT_COLLECT_RULE.FOLLOW_RENT
      ) {
        params.depositFirstPeriodAmount =
          depositItem.depositFirstPeriodAmount ?? ''
      }

      if (
        depositItem.fundType === FEE_CODE_MAP.YA_JIN &&
        Number(depositItem.depositCollectRule) ===
          DEPOSIT_COLLECT_RULE.CUSTOM_STAGES
      ) {
        params.depositInstallmentList = depositItem.depositInstallmentList ?? []
      }

      if (
        (depositItem.fundType === FEE_CODE_MAP.ZU_JIN ||
          depositItem.fundType === FEE_CODE_MAP.OTHERS) &&
        [
          PAY_MODE.WEEK,
          PAY_MODE.NATURAL_WEEK,
          PAY_MODE.FULL_MOON,
          PAY_MODE.NATURAL_MONTH,
        ].includes(Number(payMode)) &&
        depositItem.amountAccuracy !== undefined &&
        depositItem.amountAccuracy !== null
      ) {
        params.amountAccuracy = depositItem.amountAccuracy
      }

      if (
        this.rentDateInfo.preFreeRentDays !== undefined &&
        this.rentDateInfo.preFreeRentDays !== null
      ) {
        params.preFreeRentDays = this.rentDateInfo.preFreeRentDays
      }
      if (depositItem.scene !== undefined && depositItem.scene !== null) {
        params.scene = depositItem.scene
      }
      return params
    },
    // 设置值
    // eslint-disable-next-line vue/no-unused-properties
    async setData(data) {
      this._isSettingData = true
      this.baseDefaultValue.id = this.id
      this.baseDefaultValue.gmtCreate = data.gmtCreate
      this.baseDefaultValue.name =
        this.mode === MODE_TYPE.COPY ? `${data.name}-复制` : data.name

      // 品牌车系车型
      this.baseDefaultValue.brandId = data.brandId ? Number(data.brandId) : ''
      this.baseDefaultValue.seriesId = data.seriesId
        ? Number(data.seriesId)
        : ''
      this.baseDefaultValue.modelId = data.modelId ? Number(data.modelId) : ''
      this.baseDefaultValue.brandSeriesModel = {
        brandId: this.baseDefaultValue.brandId,
        seriesId: this.baseDefaultValue.seriesId,
        modelId: this.baseDefaultValue.modelId,
      }
      this.baseDefaultValue.brandSeriesModelName = {
        brandName: data.brandName,
        seriesName: data.seriesName,
        modelName: data.modelName,
      }

      // 合同模板
      this.baseDefaultValue.templateId =
        data.templateId && data.templateState === TEMPLATE_STATE_MAP.QI_YONG
          ? Number(data.templateId)
          : ''
      this.baseDefaultValue.cityCodes = data.cityCodes || []
      this.baseDefaultValue.cityNames = data.cityNames || []
      this.baseDefaultValue.state = data.state

      // 新增字段回填（兜底默认值）
      this.baseDefaultValue.carAge = data.age ?? ''
      this.baseDefaultValue.hasDrivingLicense = data.carCert ?? 1
      this.baseDefaultValue.storeIds = (data.storeList || []).map(
        (s) => s.storeId,
      )

      // 租赁规则
      this.leaseInfoParams.rentCategory = data.rentCategory
      this.leaseInfoParams.rentPeriod = data.rentPeriod
        ? String(data.rentPeriod)
        : ''
      this.leaseInfoParams.rentPeriodType = data.rentPeriodType
      this.leaseInfoParams.payPlanFee = data.payPlanFee
      this.leaseInfoParams.payMode = data.payMode
      this.rentDateInfo = { ...this.leaseInfoParams }
      this.defaultTable = data.orderPlanFeeList || []

      // 模板信息
      this.defaultTemplateValue.id = data.templateId
      this.defaultTemplateValue.name = data.templateName

      // 司机权益（活动绑定）- 复制模式下不复制关联活动
      if (this.mode !== MODE_TYPE.COPY) {
        const activityList = data.activityList || []
        this.campaignBinding = activityList.map((item) => ({
          campaignId: item.activityId,
          campaignName: item.activityName,
        }))
      }

      // 履约条款
      this.$nextTick(() => {
        if (this.$refs.leaseRulesRef) {
          this.$refs.leaseRulesRef.setFormData({
            rentCarRuleTip: data.rentCarRuleTip,
            returnCarRuleTip: data.returnCarRuleTip,
            rentCarRule: data.rentCarRule,
            returnCarRule: data.returnCarRule,
          })
        }
      })

      if (this.mode === MODE_TYPE.COPY) {
        this.$message.success('方案复制成功')
      }
    },
    // 提交事件
    async submitHandle() {
      const formValid = await new Promise((resolve) => {
        this.$refs.formRef.validate((valid) => resolve(valid))
      })
      if (!formValid) {
        this.$message.error('请先将【方案基本信息】的必填字段填写完整')
        this.$refs?.formRef?.$el?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        })
        return
      }

      // 租赁基本信息
      const rentInfoData = this.$refs.schemeRentInfo.getFormData()
      if (!rentInfoData) return

      let payPlanFee = null
      let tableData = []

      if (
        this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI
      ) {
        payPlanFee = await this.$refs.driverCooperRef.getFormData()
        if (!payPlanFee) {
          this.$message.error('请填写司机规则带有红色 * 的内容')
          return
        }
      } else {
        if (!this.$refs.RentPlanConfig) {
          this.$message.error('请选择合同模板')
          return
        }
        tableData = this.$refs.RentPlanConfig.getFormData()
        if (!tableData) return
        tableData = tableData.map((item) => {
          if (Number(item.fundType) === FEE_CODE_MAP.YA_JIN) {
            return { ...item, totalAmount: item.amount }
          }
          return item
        })
      }

      // 合同模板校验
      const templateIdValid =
        await this.$refs.chooseContractTemplateRef.validateForm()
      if (!templateIdValid) {
        this.$message.error('请选择合同模板')
        return
      }

      // 履约条款数据
      const leaseRuleData = await this.$refs.leaseRulesRef.validateForm()
      if (!leaseRuleData) return

      // 门店校验
      const storeFormValid = await new Promise((resolve) => {
        this.$refs.storeFormRef.validate((valid) => resolve(valid))
      })
      if (!storeFormValid) {
        this.$message.error('请选择可发车门店')
        return
      }

      const baseInfoData = { ...this.baseDefaultValue }

      // 押金校验
      const depositCheckValid = await this.validateFollowRentDeposit(tableData)
      if (!depositCheckValid) return

      const postParams = {
        name: baseInfoData.name,
        modelId: baseInfoData.modelId,
        templateId: baseInfoData.templateId || undefined,
        cityCodes: baseInfoData.cityCodes,
        age: baseInfoData.carAge,
        carCert: baseInfoData.hasDrivingLicense,
        payMode: rentInfoData.payMode,
        storeIdList: baseInfoData.storeIds,
        rentCategory: rentInfoData.rentCategory,
        rentPeriod: rentInfoData.rentPeriod,
        rentPeriodType: rentInfoData.rentPeriodType,
        rentFeeList: tableData,
        payPlanFee,
        rentCarRule: leaseRuleData?.rentCarRule,
        returnCarRule: leaseRuleData?.returnCarRule,
        activityIdList: this.campaignBinding.map((v) => v.campaignId),
      }

      if (this.mode === MODE_TYPE.COPY) {
        postParams.state = 0
      } else if (this.mode === MODE_TYPE.EDIT) {
        postParams.id = Number(this.id)
        postParams.state = baseInfoData.state
      } else {
        postParams.state = 10
      }

      // 保存前排重
      const checkRes = await checkBeforeSave(postParams)
      if (checkRes.code !== 1 || checkRes.data === false) {
        this.$message.error(checkRes.msg || '方案排重校验不通过')
        return
      }

      // 提交
      this.oLoading.submit = true
      const res = await saveLeaseSchemeSignCheck(postParams)
      if (res.code === 1) {
        this.$message.success(
          this.mode === MODE_TYPE.EDIT ? '修改成功' : '添加成功',
        )
        if (this.$route.query.scene) {
          const communication = new WindowCommunication('lease_scheme_added')
          communication.send(true)
          window.close()
          return
        }
        this.goPageBacks(true)
      }
      this.oLoading.submit = false
    },
    async validateFollowRentDeposit(tableData = []) {
      const depositItem = tableData.find((item) => {
        return (
          Number(item.fundType) === FEE_CODE_MAP.YA_JIN &&
          Number(item.depositCollectRule) === DEPOSIT_COLLECT_RULE.FOLLOW_RENT
        )
      })
      if (!depositItem) {
        return true
      }
      const params = this.buildFollowRentDepositPreviewParams(depositItem)
      const res = await depositAmountCheck(params)
      if (res.code === 1 && res.data === false) {
        this.$message.error(
          res.msg || '押金校验不通过，请检查随租金周期收取配置',
        )
        return false
      }
      return true
    },
    formChange() {
      // 司机合作模式切换预计租赁日期清空司机结算
      if (
        this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI
      ) {
        this.$refs.driverCooperRef.clearFormData()
      }
    },
    setTemplateIdAndAIResultInfo(info) {
      this.baseDefaultValue.templateId = info.templateId
    },
    async fetchCarAgeOptions() {
      const { code, data } = await getEnum({ type: 'carAgeEnum' })
      if (code === 1) {
        this.carAgeOptions = data || []
      }
    },
    async fetchStoreByCity(cityCodes) {
      const { code, data } = await storeListAll({ cityCodes })
      if (code === 1) {
        this.storeTransferList = (data || []).map((item) => ({
          key: item.id,
          label: item.name,
        }))
      }
    },
    async fetchSignCompany() {
      const { code, data } = await getSimpleMerchantList({ defaultType: 0 })
      if (code === 1 && data && data.length) {
        this.signCompany = data[0].corporationName || ''
      }
    },
    confirmStoreSelection() {
      this.baseDefaultValue.storeIds = [...this.storeDialogSelectedIds]
      this.storeDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.qs-scrollerBox {
  margin-right: 0;
}
::v-deep .bottom-action-inner {
  bottom: 12px;
}
::v-deep .qs-h4-no-border {
  padding-bottom: 0;
}
.content-box {
  &__title {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #1d2129;
    display: flex;
    align-items: center;
    background: #f7f9fd;
    height: 38px;
    .icon {
      width: 4px;
      height: 16px;
      background: #2a6bff;
      margin-right: 8px;
    }
  }
  &__content {
    width: 720px;
    margin: 0 auto;
  }
}
.content-item {
  .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: #1d2129;
    margin-bottom: 11px;
  }
}
.basic-info {
  ::v-deep .el-column-box {
    gap: 0 24px;
  }
  ::v-deep .el-form-item {
    display: flex;
    flex-direction: column;
    width: 348px !important;
  }
  ::v-deep .el-form-item__label {
    justify-content: flex-start;
  }
  ::v-deep .el-cascader {
    width: 100%;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-input {
    width: 100%;
  }
  ::v-deep .column-box {
    gap: 0 24px;
  }
}
.store-select-wrap {
  display: flex;
  gap: 12px;
  width: 100%;
  .store-name-select {
    flex: 1;
  }
}

.store-transfer-dialog {
  ::v-deep .el-dialog {
    width: fit-content;
    min-width: 520px;
  }
}

.form-box {
  ::v-deep .el-form-item__label {
    justify-content: flex-start;
  }
}
</style>
<style lang="scss">
.plan-city-popper {
  .el-select-dropdown__wrap {
    width: 100% !important;
  }
}
</style>
